import { render, staticRenderFns } from "./dictionaryManagement.vue?vue&type=template&id=2470df74&"
import script from "./dictionaryManagement.vue?vue&type=script&lang=js&"
export * from "./dictionaryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports